var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0212 9L15.2927 5.72845C15.4949 5.52633 15.4949 5.19793 15.2927 4.99583L13.4486 3.15159C13.2465 2.94947 12.9181 2.94947 12.716 3.15159L9.44443 6.42314L6.17288 3.15159C5.97076 2.94947 5.64236 2.94947 5.44026 3.15159L3.59602 4.99583C3.3939 5.19795 3.3939 5.52635 3.59602 5.72845L6.86757 9L3.59602 12.2715C3.3939 12.4737 3.3939 12.8021 3.59602 13.0042L5.44026 14.8484C5.64238 15.0505 5.97078 15.0505 6.17288 14.8484L9.44443 11.5769L12.716 14.8484C12.9181 15.0505 13.2465 15.0505 13.4486 14.8484L15.2928 13.0042C15.495 12.802 15.495 12.4736 15.2928 12.2715L12.0212 9Z",
    fill: "#C53030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/Wrong.fb3998d15406bfb27eb61119bf482086.svg";
export { ForwardRef as ReactComponent };